<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 8L5.83333 13L14.5 3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
